import { Component } from '@angular/core';
import { SvgIcons } from '@ngneat/svg-icon';
import { projectBigIcons, projectIcons } from '../../shared/icon/svg-icons-settings';

@Component({
  selector: 'tax-dev-icons',
  templateUrl: 'dev-icons.component.html',
  styleUrls: ['dev-icons.component.sass'],
})

export class DevIconsComponent {
  icons = projectIcons.map(icon => icon.name as SvgIcons);

  bigIcons = projectBigIcons.map(icon => icon.name as SvgIcons);
}
